import type { StoreFacts } from './storeFacts';

// The steps back from the page being looked at, read off what the page already knows: a product page is
// Home, then the product; a collection page is Home, then the collection; anything else is Home alone.

/** One step of the trail: its words, and where it leads unless it is the page itself. */
export type TrailStep = { label: string; href?: string };

// Builds the trail for one page, ending at the page itself: a collection page at its collection, not the cart's product.
export function breadcrumbTrail(store: StoreFacts | null, homeLabel: string): TrailStep[] {
  const home: TrailStep = { label: homeLabel, href: '/' };
  if (store?.collection?.title) return [home, { label: store.collection.title }];
  if (store?.product?.title) return [home, { label: store.product.title }];
  return [home];
}
